<script>
    import { info_attributes } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/config/product_tab_attributes.js?1733898724687';
    import { get_attribute_label, get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724687';
    import Attribute from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/tab/Attribute.svelte?1733898724687';
    import Row from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/tab/Row.svelte?1733898724687';

    export let product;
    export let brand;
</script>

{#if product}
    <table class="u-table">
        <tbody>
            {#if brand && product.pim_brand}
                <tr>
                    <th>{get_attribute_label(product, 'pim_brand')}</th>
                    <td><a href={brand.url}>{brand.name}</a></td>
                </tr>
            {/if}

            {#each info_attributes as attribute}
                <Row {product} {attribute} />
            {/each}
        </tbody>
    </table>
{/if}




<style>
    th{
        text-align: left;
    }
    :global(th){
        text-align: left;
    }
</style>